import { assert } from '@ember/debug';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import focusDropdownSearch from 'scaleflow/utils/focus-dropdown-search';
import nameSort from 'scaleflow/utils/nameSort';

export default class DropdownsTeamsComponent extends Component {
  @service store;

  @tracked textFilter = '';

  @tracked tippyInstance = null;

  get ComponentName() {
    return this.args?.tippy ? 'Tippy' : 'empty-component';
  }

  get teams() {
    const teams = this.store.peekAll('team');
    const initiative = this.args.initiative;
    const initiative_teams = (initiative?.teams?.content ?? []).reduce(
      (acc, item) => {
        acc[item.id] = true;
        return acc;
      },
      {},
    );
    return teams
      .filter((item) => item.active || initiative_teams[item.id])
      .map((item) => ({ label: item.name, value: item.id }));
  }

  get trigger() {
    return this.args?.trigger ?? 'click';
  }

  get placement() {
    return this.args.placement ?? 'top';
  }

  get interactive() {
    return this.args.interactive ?? true;
  }

  get searchable() {
    return this.store.peekAll('team').filter((team) => team.active).length > 6;
  }

  @action
  handleTeamClick(item) {
    this.args?.onSelect?.(item);
    this.tippyInstance.hide();
    return;
  }

  get teamsList() {
    const teams = this.store.peekAll('team').filter((item) => item.active);
    const filteredTeams = !this.textFilter
      ? teams
      : teams.filter(
          (item) =>
            item.name.toLowerCase().indexOf(this.textFilter.toLowerCase()) >= 0,
        );
    return filteredTeams.sort((a, b) => nameSort(a.name, b.name));
  }

  @action
  handleSearch(text) {
    this.textFilter = text;
  }

  @action
  onShown(instance) {
    focusDropdownSearch(instance);
  }

  @action
  onCreate(e) {
    this.tippyInstance = e;
  }

  @action
  handleClearSelection() {
    this.args?.handleClearSelection();
    this.tippyInstance.hide();
  }

  @action
  handleAddTeam() {
    if (
      !this.args.onAddTeamClick ||
      typeof this.args?.onAddTeamClick !== 'function'
    )
      assert(
        'An "onAddTeamClick" callback needs to be passed to this component',
      );
    this.args?.onAddTeamClick?.();
  }
}
